import { render, staticRenderFns } from "./goodsNew.vue?vue&type=template&id=34b96514&scoped=true&"
import script from "./goodsNew.vue?vue&type=script&lang=js&"
export * from "./goodsNew.vue?vue&type=script&lang=js&"
import style0 from "./goodsNew.vue?vue&type=style&index=0&id=34b96514&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b96514",
  null
  
)

export default component.exports